import React, { useEffect, useState } from "react";
import {
  Region,
  SectorData,
  SectorPeerComparisonWidget,
  WidgetError,
  ThemeType,
  SectorPeerComparisonWidgetProps,
  WidgetMessage,
  WidgetHeightMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";

const SectorPeerComparison: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const region = queryParams.get("region") || Region.AU;
  const [sector, setSector] = useState(queryParams.get("sector") || "");
  const token = queryParams.get("token") || "";
  const tab = queryParams.get("tab") || "";
  const theme = queryParams.get("theme") || ThemeType.Direct;

  useEffect(() => {
    window.addEventListener("message", (event) => {
      console.log("message", event);
      if (event.data && event.data.type === "sector") {
        let msg = event.data as SectorData;
        setSector(msg.data.sector);
      }
    });
    return () => {
      window.removeEventListener("message", (event) => {
        console.log("message", event);
      });
    };
  }, []);

  const handleCallback = (message: WidgetMessage) => {
    console.log("handleCallback", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(message),
        "*",
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.SectorPeerComparison,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };

  const props: SectorPeerComparisonWidgetProps = {
    region: region as Region,
    sector: sector,
    token: token,
    tab: tab,
    theme: theme as ThemeType,
    onCallback: handleCallback,
    onNoData: handleNoData,
    onError: handleError,
    onLoadingChange: handleLoadingChange,
    onHeightChange: handleHeightChange,
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <SectorPeerComparisonWidget {...props} />
    </Spin>
  );
};

export default SectorPeerComparison;
